import { render } from "./AdvisoryBoard.vue?vue&type=template&id=1e1270f2"
import script from "./AdvisoryBoard.vue?vue&type=script&lang=js"
export * from "./AdvisoryBoard.vue?vue&type=script&lang=js"

import "./AdvisoryBoard.vue?vue&type=style&index=0&id=1e1270f2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__